import { Icon, useDisclosure } from '@chakra-ui/react';
import type { CardProps } from '@ui/components/Card';
import { Card } from '@ui/components/Card';
import type { LiquidityStrategyDepositToken } from '@ui/utils/strategy';
import { LiquidityStrategyTokenDict } from '@ui/utils/strategy';
import { ArrowDown } from '@veno-app/icons';
import type { FC } from 'react';

import { StrategyTokenSelectionDrawer } from './StrategyTokenSelectionDrawer';

export type TokenSelectionButtonProps = Omit<
  CardProps,
  'value' | 'onChange'
> & {
  value: LiquidityStrategyDepositToken;
  preferred?: LiquidityStrategyDepositToken;
  onChange: (value: LiquidityStrategyDepositToken) => void;
};
export const TokenSelectionButton: FC<TokenSelectionButtonProps> = ({
  value,
  onChange,
  preferred,
  ...props
}) => {
  const tokenSelectionDrawerDisclosure = useDisclosure();
  const tokenInfo = LiquidityStrategyTokenDict[value];

  return (
    <>
      <Card
        display="flex"
        justifyContent="center"
        alignItems="center"
        mx="0"
        cursor="pointer"
        {...props}
        onClick={(e) => {
          tokenSelectionDrawerDisclosure.onOpen();
          props.onClick?.(e);
        }}
      >
        <tokenInfo.Icon width="30px" height="30px" />
        <Icon as={ArrowDown} width="22px" height="22px" />
      </Card>
      <StrategyTokenSelectionDrawer
        preferred={preferred}
        isOpen={tokenSelectionDrawerDisclosure.isOpen}
        onClose={tokenSelectionDrawerDisclosure.onClose}
        value={value}
        onChange={onChange}
      />
    </>
  );
};
